import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  GetServiceDetailProviderResponse,
  ProductBase,
  ProviderServiceDetail,
} from 'src/app/models/service-detail/service-detail.model';
import { HistoryServicesService } from 'src/app/services/history-services/history-services.service';
import { NoProviderService } from 'src/app/shared/gantt/interfaces/NoProviderService.model';

@Component({
  selector: 'app-select-provider-list',
  templateUrl: './select-provider-list.component.html',
  styleUrls: ['./select-provider-list.component.css'],
})
export class SelectProviderListComponent {
  @Input() ServiceSelected: NoProviderService | undefined;
  @Input() ProductId: string | undefined;
  @Input() Product: ProductBase | undefined;
  @Input() ZoneId: string | undefined;
  @Input() ProviderSelected: ProviderServiceDetail | undefined = undefined;
  @Input() MinHeight: string | undefined = 'calc(100vh -517px)';
  @Input() MaxHeight: string | undefined = 'calc(100vh -517px)';

  @Output() providerSelectEmitter = new EventEmitter<ProviderServiceDetail>();

  Providers: ProviderServiceDetail[] = [];
  FilteredProviders: ProviderServiceDetail[] = [];
  LoadingData: boolean = false;

  @ViewChild('searchInputProvider')
  searchInputProvider!: ElementRef<HTMLInputElement>;

  constructor(private HistoryServicesService: HistoryServicesService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      ((changes['ServiceSelected'] && this.ServiceSelected) ||
        (changes['ProductId'] && this.ProductId)) &&
      this.ZoneId
    ) {
      this.loadProvidersData(this.ZoneId);
    }
  }

  loadProvidersData(zoneId: string) {
    this.LoadingData = true;
    this.HistoryServicesService.getProviders(zoneId).subscribe(
      (data: GetServiceDetailProviderResponse) => {
        this.LoadingData = false;
        this.Providers = this.filterByProuctId(data.providersInZone);
        this.searchInputProvider.nativeElement.value = '';
        this.filterProvider('');
        this.checkProductProviderExist();
      }
    );
  }

  checkProductProviderExist() {
    if (this.Product && this.Product.isProviderAssigned) {
      let provider = this.Providers.filter(
        (provider: ProviderServiceDetail) => {
          return provider.address == this.Product?.address;
        }
      );
      if (provider && provider[0]) {
        this.selectProvider(provider[0]);
      }
    }
  }

  filterByProuctId(
    providers: ProviderServiceDetail[]
  ): ProviderServiceDetail[] {
    return providers.filter((provider: ProviderServiceDetail) => {
      if (this.ProductId) {
        return provider.productIds.includes(this.ProductId);
      }
      return provider;
    });
  }

  selectProvider(provider: ProviderServiceDetail): void {
    this.ProviderSelected = provider;
    this.providerSelectEmitter.emit(this.ProviderSelected);
  }

  filterProvider(text: string): void {
    if (text == '') {
      this.FilteredProviders = [...this.Providers];
    } else {
      let textToFilter = this.normalizeText(text).toLocaleLowerCase();
      this.FilteredProviders = [...this.Providers].filter(
        (provider: ProviderServiceDetail) => {
          return (
            this.normalizeText(provider.address ?? '')
              .toLowerCase()
              .includes(textToFilter) ||
            this.normalizeText(provider.name)
              .toLowerCase()
              .includes(textToFilter)
          );
        }
      );
    }
  }

  focusInputProvider(): void {
    this.searchInputProvider.nativeElement.focus();
  }

  normalizeText(str: string): string {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }
}
